import Footer from "@/components/layout/admin/FooterPage.vue";
import axios from "axios";
import store from '@/store';
import {
  required,
  minLength,
  maxLength,
  sameAs
} from "vuelidate/lib/validators";

export default {
  name: "UpdatePassword",
  components: {
    Footer,
  },

  data() {
    return {
      updatePass: {
        newPassword: '',
        confirmPassword: '',
      },
      submitted: false,
      campusId: store.state.user.campus_master.campus_code,
      disabled: false,
    };
  },

  validations: {
    updatePass: {
      newPassword: {
        required,
        minLength: minLength(8),
        maxLength: maxLength(20)
      },
      confirmPassword: {
        required,
        sameAsPassword: sameAs('newPassword')
      }
    },
  },

  methods: {
    async updatePassword() {
      this.submitted = true;
      if (this.$v.$invalid) {
        return;
      }
      this.disabled = true;

      try {
        const response = await axios.post('updatePassword', {
          password: this.updatePass.newPassword
        });

        if (response.data.status == 200) {
          this.$notification.success(response.data.message, {
            timer: 3,
            position: 'bottomCenter',
          });

          this.$store.commit('logout');
          this.$router.push({ name: 'login' });
        } else {
            this.disabled = false;

            this.$notification.error(response.data.message, {
              timer: 3,
              position: 'bottomCenter',
            });
        }
      } catch (error) {
        this.disabled = false;
        this.$notification.error(
          error.response?.data?.message || 'An error occurred while updating password.',
          {
            timer: 3,
            position: 'bottomCenter',
          }
        );
      }
    }
  },
};
